<template>
  <template v-for="(group, index) in groups">
    <template v-if="isGroupContainer(group)">
      <ConversationMessageGroupSamedayContainer
        v-if="group.type === GroupType.SAMEDAY"
        :group="group"
        :is-group-conversation
        :conversation-sid
      />
      <ConversationMessageGroupSameauthorContainer
        v-else-if="group.type === GroupType.SAMEAUTHOR"
        :group="group"
        :is-group-conversation
        :conversation-sid
        :current-user
      />
      <ConversationMessageGroupMediaonlyContainer
        v-else-if="group.type === GroupType.MEDIAONLY"
        :group="group"
        :is-group-conversation
        :conversation-sid
        :current-user
      />
    </template>
    <template v-else-if="isGroupFamily(group)">
      <ConversationMessageGroupSamedayFamily
        v-if="group.type === GroupType.SAMEDAY"
        :group="group"
        :is-group-conversation
        :conversation-sid
        :current-user
        :is-first-group="index === 0"
        @report-message="(message) => $emit('reportMessage', message)"
        @images-preview="
          (images, index) => $emit('imagesPreview', images, index)
        "
      />
      <ConversationMessageGroupSameauthorFamily
        v-if="group.type === GroupType.SAMEAUTHOR"
        :group="group"
        :is-group-conversation
        :conversation-sid
        :current-user
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import {
  isGroupContainer,
  isGroupFamily,
  GroupType,
} from "~/composables/messages";
import type { UserDisplayData } from "./common";

defineProps<{
  groups: MessageGroupFamilyOrContainer[];
  conversationSid: string;
  isGroupConversation: boolean;
  currentUser: UserDisplayData;
}>();

defineEmits<{
  (e: "imagesPreview", images: string[], index: number): void;
  (e: "reportMessage", message: Message): void;
}>();
</script>
